import { render, staticRenderFns } from "./AuthSocialLoginButton.vue?vue&type=template&id=8948b196&scoped=true&"
import script from "./AuthSocialLoginButton.vue?vue&type=script&lang=js&"
export * from "./AuthSocialLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./AuthSocialLoginButton.vue?vue&type=style&index=0&id=8948b196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8948b196",
  null
  
)

export default component.exports